module.exports = __webpack_public_path__ + "static/media/cover.12dbfea2.jpg";